module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "rectangle-5.c4e5dce8.svg";